const termsContent = [
  {
    id: "ketentuan-umum",
    number: "1.",
    title: "Ketentuan Umum",
    content: [
      "Dengan menggunakan Wedify, Anda menyetujui semua ketentuan yang berlaku.",
      "Wedify berhak mengubah ketentuan layanan kapan saja tanpa pemberitahuan sebelumnya.",
    ],
  },
  {
    id: "akun-pengguna",
    number: "2.",
    title: "Akun Pengguna",
    content: [
      "Pengguna wajib mendaftar dengan informasi yang valid (nama, email, nomor WhatsApp, dll.).",
      "Keamanan akun menjadi tanggung jawab pengguna. Jika ada akses tidak sah, segera laporkan ke tim Wedify.",
      "Wedify berhak menonaktifkan akun yang terindikasi melanggar kebijakan layanan.",
    ],
  },
  {
    id: "paket-layanan",
    number: "3.",
    title: "Paket Layanan",
    content: [
      "Wedify menyediakan 3 paket: Basic (Gratis), Premium (Berbayar), dan VIP (Berbayar dengan fitur tambahan).",
      "Paket Premium & VIP hanya dapat diakses setelah pembayaran berhasil.",
      "Paket berbayar tidak dapat dikembalikan setelah pembelian selesai.",
      "Pengguna akan diberi tahu melalui email atau dashboard jika ada perubahan signifikan pada layanan atau ToS.",
      "Jika ada maintenance, akan diberikan pemberitahuan sebelumnya ke pengguna.",
    ],
  },
  {
    id: "pembayaran",
    number: "4.",
    title: "Pembayaran",
    content: [
      "Pembayaran dapat dilakukan melalui QRIS, Gopay, Ovo, DANA, dan metode lain yang tersedia.",
      "Jika terjadi kegagalan transaksi, pengguna dapat menghubungi tim customer service Wedify.",
    ],
  },
  {
    id: "tema-undangan",
    number: "5.",
    title: "Penggunaan Tema & Undangan",
    content: [
      "Pengguna dapat memilih tema undangan digital yang tersedia sesuai dengan paketnya.",
      "Tema berbayar hanya dapat digunakan setelah pembelian dilakukan.",
      "Pengguna bertanggung jawab atas kebenaran informasi yang dimasukkan dalam undangan.",
    ],
  },
  {
    id: "konten-data",
    number: "6.",
    title: "Konten & Data Pengguna",
    content: [
      "Pengguna bertanggung jawab atas semua konten yang diunggah ke Wedify, termasuk foto dan informasi pribadi.",
      "Wedify tidak bertanggung jawab atas penyalahgunaan informasi oleh pihak ketiga.",
      "Wedify dapat menghapus atau menolak konten yang melanggar hukum atau kebijakan layanan.",
    ],
  },
];

export default termsContent;
